<script setup>
/**
 * PressBar — small authority bar with press / award placeholders.
 *
 * Pattern: Insightful's "Forbes mention" + ClickUp's award row, but compact
 * (one line on desktop). Goes right after ROIStatsBlock so the credibility
 * stack reads: numbers → press authority → customer logos.
 *
 * Marketing team replaces each <div> with a real press/award SVG when ready.
 */
import { useI18n } from "vue-i18n";

const { t } = useI18n();

// 4 placeholders. Real logos go here when available (Forbes, TechCrunch,
// G2, Capterra, ProductHunt, etc.).
const slots = ["Forbes", "TechCrunch", "G2 Leader", "Capterra"];
</script>

<template>
  <section class="py-10 bg-background border-b border-border">
    <div class="container mx-auto px-6">
      <div class="flex flex-col md:flex-row md:items-center md:justify-center gap-5 md:gap-10">
        <p class="text-xs font-semibold uppercase tracking-widest text-muted-foreground text-center md:text-left">
          {{ t("landing.press_bar.heading") }}
        </p>
        <div class="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          <div
            v-for="(name, i) in slots"
            :key="i"
            class="h-8 px-3 inline-flex items-center justify-center text-[11px] uppercase tracking-wider text-muted-foreground/70 font-mono border border-dashed border-border rounded grayscale opacity-80 hover:opacity-100 hover:grayscale-0 transition-all"
          >
            {{ name }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
